import React, { useState } from "react";
import Navbar from "@/components/audioflip/Navbar";
import Hero from "@/components/audioflip/Hero";
import Features from "@/components/audioflip/Features";
import Pricing from "@/components/audioflip/Pricing";
import Footer from "@/components/audioflip/Footer";
import AudioPlayer from "@/components/audioflip/AudioPlayer";
import AdminPanel from "@/auth/AdminPanel";
import { useAuth } from "@/auth/AuthContext";

export default function AudioFlipPage() {
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioMeta, setAudioMeta] = useState(null);
  const { isAdmin } = useAuth();

  const setNewAudio = (url, meta) => {
    if (audioUrl && audioUrl !== url) URL.revokeObjectURL(audioUrl);
    setAudioUrl(url);
    setAudioMeta(meta);
  };

  const closeAudio = () => {
    if (audioUrl) URL.revokeObjectURL(audioUrl);
    setAudioUrl(null);
    setAudioMeta(null);
  };

  return (
    <div data-testid="audioflip-page" className="min-h-screen bg-white text-zinc-950 relative">
      <Navbar />
      <main className={audioUrl ? "pb-32" : "pb-0"}>
        <Hero onAudioReady={setNewAudio} />
        <Features />
        <Pricing />
        {isAdmin && <AdminPanel />}
        <Footer />
      </main>
      {audioUrl && (
        <AudioPlayer src={audioUrl} meta={audioMeta} onClose={closeAudio} />
      )}
    </div>
  );
}
